import { Component } from '@angular/core';

export const CASS_ACCOUNT_TYPES = ['Distributor', 'Supplier'];

const CASS_ACCOUNT_TYPE_LABELS: {[type: string]: string} = {
  Distributor: 'Distributor Only',
  Supplier: 'Supplier Only',
};

// the api keeps the type values as they are, only the displayed text changes
export const getCassAccountTypeLabel = (type: string) => type ? CASS_ACCOUNT_TYPE_LABELS[type] || type : 'Default';

@Component({
  selector: 'exa-cass-account-type-cell',
  template: `
    <div class="type-select" *ngIf="params?.data" [ngClass]="'type-select--' + (value || 'none').toLowerCase()">
      <mat-select
          [value]="value"
          [placeholder]="getLabel(null)"
          disableOptionCentering
          panelClass="cass-type-panel"
          (selectionChange)="onChange($event.value)">
        <mat-option *ngFor="let type of types" [value]="type">{{getLabel(type)}}</mat-option>
      </mat-select>
    </div>
  `,
  styles: [`
    :host {
      display: flex;
      align-items: center;
      height: 100%;
    }

    .type-select {
      display: flex;
      align-items: center;
      width: 110px;
      height: 28px;
      padding: 0 10px;
      box-sizing: border-box;
      border: 1px solid #c4c4c4;
      border-left-width: 4px;
      border-radius: 4px;
      background-color: #fff;
      cursor: pointer;
      transition: border-color .15s ease, box-shadow .15s ease;
    }

    .type-select:hover {
      border-color: #8a8a8a;
      box-shadow: 0 1px 3px rgba(0, 0, 0, .12);
    }

    .type-select--distributor {
      border-left-color: #1e88e5;
    }

    .type-select--supplier {
      border-left-color: #fb8c00;
    }

    .type-select--none {
      border-left-color: #bdbdbd;
    }

    .type-select mat-select {
      font-size: 13px;
      font-weight: 500;
    }
  `],
})
export class CassAccountTypeCellComponent {
  params: any;
  value: string;
  types = CASS_ACCOUNT_TYPES;
  getLabel = getCassAccountTypeLabel;

  agInit(params: any) {
    this.params = params;
    this.value = params.value;
  }

  refresh(params: any): boolean {
    this.agInit(params);
    return true;
  }

  onChange(newValue: string) {
    const oldValue = this.value;
    this.value = newValue;

    this.params.context.componentParent.onTypeChanged(this.params.data, newValue, () => {
      this.value = oldValue;
    });
  }
}
